import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { MODULE_ROUTES } from "../lib/moduleRoutes";

// Immer erreichbar, unabhängig von der Modul-Freigabe.
const ALWAYS_ALLOWED = ["/mein-konto"];
// Bevorzugte Startseite für eingeschränkte Nutzer (erste Übereinstimmung gewinnt).
const HOME_PRIORITY = ["shipping-monitor", "picking-list", "products", "warehouse", "pallets", "dashboard"];

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/40">
      <div className="text-sm text-muted-foreground uppercase tracking-[0.2em] font-semibold">Wird geladen…</div>
    </div>
  );
}

export default function ProtectedRoute({ children, roles }) {
  const { user, modules, modulesLoaded } = useAuth();
  const location = useLocation();

  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  // Erst rendern, wenn die erlaubten Module bekannt sind — verhindert das
  // kurzzeitige Aufblitzen falscher Module und Fehl-Weiterleitungen.
  if (!modulesLoaded) return <Loading />;

  // Nutzer mit expliziter Modul-Liste (eigene Rolle): Routen-Zugriff folgt exakt
  // den im Rollen-Editor freigegebenen Modulen.
  if (Array.isArray(modules)) {
    const path = location.pathname;
    const allowed = modules.map((m) => MODULE_ROUTES[m]).filter(Boolean).concat(ALWAYS_ALLOWED);
    const ok = allowed.some((p) => (p === "/" ? path === "/" : path === p || path.startsWith(p + "/")));
    if (!ok) {
      const homeModule = HOME_PRIORITY.find((m) => modules.includes(m));
      const home = (homeModule && MODULE_ROUTES[homeModule]) || allowed[0] || "/mein-konto";
      return <Navigate to={home} replace />;
    }
    return children;
  }

  // Basisrolle ohne Einschränkung: klassische Rollenprüfung.
  // Fallback ist "/mein-konto" statt "/": seit das Dashboard (Pfad "/") selbst
  // eine Rollenprüfung hat, würde "/" als Ziel bei fehlender Berechtigung in eine
  // Endlos-Weiterleitung laufen. "/mein-konto" ist für jede Basisrolle immer erreichbar.
  if (roles && Array.isArray(roles) && !roles.includes(user?.role)) {
    return <Navigate to="/mein-konto" replace />;
  }
  return children;
}
